module.exports = __webpack_public_path__ + "static/media/tab-icon-orders.7601a486.svg";